function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("polyline", {
  fill: "none",
  points: "   649,137.999 675,137.999 675,155.999 661,155.999  ",
  stroke: "#464ee5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), React.createElement("polyline", {
  fill: "none",
  points: "   653,155.999 649,155.999 649,141.999  ",
  stroke: "#464ee5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), React.createElement("polyline", {
  fill: "none",
  points: "   661,156 653,162 653,156  ",
  stroke: "#464ee5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M29.018,17H2.982c-0.397,0-0.756-0.244-0.908-0.617c-0.152-0.374-0.068-0.804,0.213-1.09l11.789-12    c0.384-0.391,1.005-0.391,1.389,0s0.384,1.023,0,1.414L5.354,15h23.663C29.561,15,30,15.448,30,16S29.561,17,29.018,17z",
  fill: "#464ee5"
})), React.createElement("g", null, React.createElement("path", {
  d: "M14.772,29c-0.251,0-0.503-0.098-0.695-0.293l-7.86-8c-0.384-0.391-0.384-1.023,0-1.414s1.005-0.391,1.389,0l7.86,8    c0.384,0.391,0.384,1.023,0,1.414C15.275,28.902,15.023,29,14.772,29z",
  fill: "#464ee5"
})));

var SvgIconfinderArrowLeft392526 = function SvgIconfinderArrowLeft392526(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    height: "32px",
    id: "Layer_1",
    viewBox: "0 0 32 32",
    width: "32px",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconfinderArrowLeft392526, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconfinder_Arrow-Left_392526.820f6405.svg";
export { ForwardRef as ReactComponent };